var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceSmile24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75Z",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.25C15.8284 11.25 16.5 10.5784 16.5 9.75C16.5 8.92157 15.8284 8.25 15 8.25C14.1716 8.25 13.5 8.92157 13.5 9.75C13.5 10.5784 14.1716 11.25 15 11.25Z",
    fill: "current",
    className: "filled",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25C9.82843 11.25 10.5 10.5784 10.5 9.75C10.5 8.92157 9.82843 8.25 9 8.25C8.17157 8.25 7.5 8.92157 7.5 9.75C7.5 10.5784 8.17157 11.25 9 11.25Z",
    fill: "current",
    className: "filled",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9016 15.525C14.9266 16.575 13.5016 17.25 12.0016 17.25C9.60156 17.25 7.65156 15.675 6.97656 13.5",
    stroke: "current",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7804 14.7803C18.0733 14.4874 18.0733 14.0126 17.7804 13.7197C17.4875 13.4268 17.0127 13.4268 16.7198 13.7197C16.4269 14.0126 16.4269 14.4874 16.7198 14.7803C17.0127 15.0732 17.4875 15.0732 17.7804 14.7803Z",
    fill: "current",
    className: "filled",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSmile24);
export default __webpack_public_path__ + "static/media/FaceSmile-24.da3f0e85.svg";
export { ForwardRef as ReactComponent };